import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ro from './locales/ro.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ro: { translation: ro },
      en: { translation: en },
    },
    fallbackLng: 'ro', // default RO
    lng: undefined, // lasă detectorul să decidă (localStorage > navigator)
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'platforma_ssm_lang',
    },
    interpolation: {
      escapeValue: false, // React face escape default
    },
  });

export default i18n;
